import ModelDataService from "@kea-mod/common/axios/services/ModelDataService";

// The backend can only list student solutions per exercise, not per submission.
// Load that list once per exercise and keep only the submission-to-model mapping,
// so opening further submissions of the same exercise causes no additional download.
const cachedLookups: any = {};

const loadLookup = (exerciseId: any) => {
  const key = String(exerciseId);
  if (!cachedLookups[key]) {
    cachedLookups[key] = ModelDataService.getModelforSubex(exerciseId, "studentSolution")
      .then((response: any) => {
        const lookup: any = {};
        for (const model of response.data.data) {
          lookup[model.parentId] = model.id;
        }
        return lookup;
      })
      .catch((error: any) => {
        // Failed loads are not cached so they can be retried.
        delete cachedLookups[key];
        throw error;
      });
  }
  return cachedLookups[key];
};

export const getStudentSolutionModelId = async (exerciseId: any, submissionExerciseId: any) => {
  const lookup = await loadLookup(exerciseId);
  return lookup[parseInt(submissionExerciseId as string, 10)];
};
